// extracted by mini-css-extract-plugin
export var option = "_5d-0";
export var optionCard = "_5d-f";
export var optionContent = "_5d-g";
export var optionIcon = "_5d-i";
export var optionIconBox = "_5d-h";
export var optionLabel = "_5d-j";
export var optionPill = "_5d-m";
export var optionPillBadge = "_5d-p";
export var optionPillIcon = "_5d-n";
export var optionPillLabel = "_5d-o";
export var optionRadio = "_5d-k";
export var optionRadioInner = "_5d-l";
export var optionReveal = "_5d-2";
export var optionRevealDelay0 = "_5d-3";
export var optionRevealDelay1 = "_5d-4";
export var optionRevealDelay10 = "_5d-d";
export var optionRevealDelay11 = "_5d-e";
export var optionRevealDelay2 = "_5d-5";
export var optionRevealDelay3 = "_5d-6";
export var optionRevealDelay4 = "_5d-7";
export var optionRevealDelay5 = "_5d-8";
export var optionRevealDelay6 = "_5d-9";
export var optionRevealDelay7 = "_5d-a";
export var optionRevealDelay8 = "_5d-b";
export var optionRevealDelay9 = "_5d-c";
export var optionSelected = "_5d-1";